// İSG Portal — Belge Şemaları (Document Schemas) yönetim API'si: platform belge türü kaydının
// listesi, oluşturma ve güncelleme.
//
// KAYNAK: api-contract §27.2-§27.4. Kayıt
// platform verisidir, firma kapsamı yok; anahtar `(entity, code)`, `uuid` yalnız `PUT` adreslemesi
// içindir. Herkesin okuduğu kayıt listesi (`GET /document-types`) `documentTypes.ts`'tedir; bu
// dosya yalnız `document-schemas` yetkisiyle çağrılan yönetim uçlarını taşır.
//
// Serileştirme camelCase (§1); sayfalama §3 (`total` / `filteredTotal`).

import { api } from './client';
import type {
  DocumentCaptureFormat,
  DocumentEntity,
  DocumentExpiryRule,
  DocumentTypeDto,
} from './documentTypes';

export type DocumentTypeRecognitionStatus = 'Recognised' | 'ManualOnly' | 'Unknown';

export interface DocumentTypeAdminDto extends DocumentTypeDto {
  /** Recognised: CANLI doc-check sürümü bu (entity, code)'u tanır. ManualOnly: tanımaz / canlı yok /
   * doc-check yapılandırılmamış. Unknown: katalog okunamadı → "—". */
  recognitionStatus: DocumentTypeRecognitionStatus;
  /** `recognitionStatus === 'Recognised'` iken dolu. */
  recognitionRelease: number | null;
  createdAt: string;
  updatedAt: string | null;
}

/** `GET /document-schemas/types` süzgeçleri (§4.1.2; §3 sayfalama). */
export interface DocumentTypeAdminListParams {
  search?: string;
  entity?: DocumentEntity;
  isActive?: boolean;
  page?: number;
  pageSize?: number;
}

export interface CreateDocumentTypeRequest {
  entity: DocumentEntity;
  code: string;
  labelTr: string;
  labelEn: string;
  labelDe: string;
  expiryRule: DocumentExpiryRule;
  captureFormat: DocumentCaptureFormat;
  /** Varsayılan: entity içindeki max(sortOrder) + 1. ≥ 0. */
  sortOrder?: number;
  /** Varsayılan true. */
  isActive?: boolean;
}

/** `entity` ve `code` gövdede YOK (değişmez). Değişebilir alanların tam değişimi. */
export interface UpdateDocumentTypeRequest {
  labelTr: string;
  labelEn: string;
  labelDe: string;
  expiryRule: DocumentExpiryRule;
  captureFormat: DocumentCaptureFormat;
  sortOrder: number;
  isActive: boolean;
}

/** `GET /document-schemas/types` (`list`): sayfalı yönetici listesi (§4.1.2). Yetki yoksa `403`. */
export function listDocumentTypes(params: DocumentTypeAdminListParams = {}) {
  return api.list<DocumentTypeAdminDto>('document-schemas/types', {
    searchParams: {
      search: params.search,
      entity: params.entity,
      isActive: params.isActive,
      page: params.page,
      pageSize: params.pageSize,
    },
  });
}

/** `POST /document-schemas/types` (`create`) → 201. 409 `DOCUMENT_TYPE_CODE_EXISTS`. */
export function createDocumentType(body: CreateDocumentTypeRequest) {
  return api.post<DocumentTypeAdminDto>('document-schemas/types', { json: body });
}

/** `PUT /document-schemas/types/{uuid}` (`update`). 404 `DOCUMENT_TYPE_NOT_FOUND`. */
export function updateDocumentType(uuid: string, body: UpdateDocumentTypeRequest) {
  return api.put<DocumentTypeAdminDto>(`document-schemas/types/${uuid}`, { json: body });
}
